const faqs = [
  {
    q: '黑料入口是什么平台？',
    a: '黑料入口是一个专注于收集和整理全网黑料事件、瓜田故事的综合性吃瓜平台。我们从海量信息中筛选出有价值的黑料故事，以时间线和专题的方式呈现，帮助读者清晰了解每一起黑料事件的来龙去脉和后真相追踪。',
  },
  {
    q: '黑料内容都从哪里来？',
    a: '我们的黑料故事来源于公开报道、社交平台热议、行业内部爆料以及读者投稿等多个渠道。每一篇黑料揭秘内容都经过编辑团队的交叉核实和梳理，确保信息完整可追溯，不传播未经证实的谣言。',
  },
  {
    q: '如何第一时间追到最新黑料？',
    a: '关注黑料入口首页即可看到每日更新的最新黑料动态，我们的编辑团队全天候追踪热点事件。同时你可以通过我们的专题合集快速定位感兴趣的话题领域，热度榜单也会实时反映当前最受关注的吃瓜内容。',
  },
  {
    q: '黑料入口的内容可信度如何？',
    a: '我们坚持多方核实的原则，每条黑料故事都会标注信息来源。对于还在发展中的事件，我们会持续跟踪更新，不做仓促定论。黑料入口的目标是让读者吃瓜吃得明明白白，而不是被假瓜误导。',
  },
  {
    q: '可以在黑料入口投稿爆料吗？',
    a: '非常欢迎！如果你有独家黑料线索或瓜田见闻，可以通过联系我们页面的投稿渠道提交。我们的编辑团队会认真评估每一条投稿，对于有价值的黑料故事会进行深入调查和整理后发布。',
  },
  {
    q: '黑料入口与其他吃瓜网站有什么不同？',
    a: '黑料入口不仅是简单的瓜田搬运，我们更注重黑料故事的完整叙事和后真相追踪。每一篇内容都按照事件时间线整理，并关联相关话题和人物。同时我们提供专题合集、热度榜单等多种浏览方式，让吃瓜体验更加系统和深入。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 text-center mb-3">
          常见问答
        </h2>
        <p className="text-sm text-foreground-400 text-center mb-10 md:mb-14">
          关于黑料入口，你想知道的都在这里
        </p>
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-background-50 border border-background-200/60 rounded-lg overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between px-5 md:px-6 py-4 text-sm md:text-base font-medium text-foreground-200 hover:text-foreground-100 transition-colors list-none">
                <h3 className="text-sm md:text-base font-medium pr-4">{faq.q}</h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-foreground-500 group-open:rotate-45 transition-transform duration-200">
                  <i className="ri-add-line"></i>
                </span>
              </summary>
              <div className="px-5 md:px-6 pb-5 text-sm text-foreground-400 leading-relaxed">
                {faq.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}